import { useIntParam } from 'hooks';
import { lrwSessionStore } from 'store';

type UseLrwSessionExamOverviewOptions = {
  enabled?: boolean;
};

export const useLrwSessionExamOverview = (
  options: UseLrwSessionExamOverviewOptions = {}
) => {
  const { enabled = true } = options;
  const lrwSessionId = useIntParam('sessionId');

  const {
    data: examOverview,
    isFetching,
    isError,
    error,
  } = lrwSessionStore.service.lrwSessionApi.useGetLrwSessionExamOverviewQuery(
    { lrwSessionId },
    { skip: !enabled }
  );

  const isNotFound = isError && 'status' in error && error.status === 404;

  return { examOverview, isFetching, isNotFound };
};